import React from "react";
import { Link } from "react-router-dom";

import classes from "./error.module.css";
import { useTranslation } from "react-i18next";
const Error = () => {
  const {t}=useTranslation()
  return (
    <div className={classes.pageContainer}>
      <div className={classes.pageRow}>
        <h2 className={classes.status}>404</h2>
        <p className={classes.errorMessage}>{t("page not found")}</p>
        <Link to="/" className={classes.btn1}>
          {t("Return to Home page")}
        </Link>
      </div>
    </div>
  );
};

export default Error;
